module.exports = __webpack_public_path__ + "media/images/toppingIcon-4576cd87.svg";